<template>
    <div>
        <img
            src="../assets/img/66.png"
            style="width:100%;"
            alt=""
        >
        <div class="bg animated fadeInDown ">
 
        </div>
        <div class='cz'>
            <div
                class='yztc'
                id="geloction"
                style="padding-top:10vh;"
            >
                <div class="carousel">
                    <el-carousel
                        class='carousel-warp'
                        :interval="4000"
                        type="card"
                        height="600px"
                    >
                        <el-carousel-item
                            v-for="(item,index)  in geloction"
                            :key='index'
                        >
                            <img
                                :src="item"
                                alt=""
                            >
                        </el-carousel-item>

                    </el-carousel>
                </div>
                <div class='text'>
                    <h1>车位引导</h1>
                    <br>
                    <p>可以使泊车者及时了解到停车场内空余车位的信息，快速准确进入泊位；</p>
                    <br>

                    <p>避免盲目驶入，提高交通道路利用率。</p>
                     
                    <p></p>
                </div>
            </div>
            <div class='yztc'>
                <div class='text'>
                    <div style="color: #3acf98;font-size:25px;padding-bottom:30px"> 泊位共享</div>
                   车主可将闲置车位通过app进行共享发布，<br><br>增加收入的同时也减轻停车场负担，合理利用泊位资源。
                </div>
                <div class="carousel">
                    <el-carousel
                        class='carousel-warp'
                        :interval="4000"
                        type="card"
                        height="600px"
                    >
                        <el-carousel-item
                            v-for="(item,index)  in share"
                            :key='index'
                        >
                            <img
                                :src="item"
                                alt=""
                            >
                        </el-carousel-item>

                    </el-carousel>
                </div>

            </div>
            <div class='yztc'>
                <div class="carousel">
                    <el-carousel
                        class='carousel-warp'
                        :interval="4000"
                        type="card"
                        height="600px"
                    >
                        <el-carousel-item
                            v-for="(item,index)  in monthcard"
                            :key='index'
                        >
                            <img
                                :src="item"
                                alt=""
                            >
                        </el-carousel-item>

                    </el-carousel>
                </div>
                <div class='text'>
                    <h1>
                        月卡
                    </h1>
                    <br><br>
                  <p>个人可以根据需求办理不同的包月服务,<br><br>极大的节约了停车成本，让停车更方便</p>
                  <p></p>
                </div>

            </div>
            <div class='yztc'>
                <div class='text'>
                    <h1>无感支付</h1><br><br>
                    <p>绑定车牌即可实现不停车缴费，提高车主停车体验，<br><br>减少等待时间，也将有效提升城市管理效率。</p>

                </div>
                <div class="carousel">
                    <el-carousel
                        class='carousel-warp'
                        :interval="4000"
                        type="card"
                        height="600px"
                    >
                        <el-carousel-item
                            v-for="(item,index)  in userpay"
                            :key='index'
                        >
                            <img
                                :src="item"
                                alt=""
                            >
                        </el-carousel-item>

                    </el-carousel>
                </div>

            </div>
            <div class='yztc'>
                <div class="carousel">
                    <el-carousel
                        class='carousel-warp'
                        :interval="4000"
                        type="card"
                        height="80vh"
                    >
                        <el-carousel-item
                            v-for="(item,index)  in fapiao"
                            :key='index'
                        >
                            <img
                                :src="item"
                                alt=""
                            >
                        </el-carousel-item>

                    </el-carousel>
                </div>
                <div class='text'>
                     <h1>电子发票</h1><br><br>
                     <p>停车缴费后即可在app内开具电子发票，<br><br>方便企业使用停车费电子发票，进行财务管理，发票核销。</p>
                </div>

            </div>
        </div>

    </div>

</template>
<script>


export default {
  components: {
  
  },
  name: 'cz',
  data() {
    return {
      geloction: [
        require('../assets/img/geloction1.png'),
        require('../assets/img/geloction2.png'),
        require('../assets/img/geloction3.png'),
      ],
      share: [
        require('../assets/img/share1.png'),
        require('../assets/img/share3.png'),
        require('../assets/img/share2.png'),
        require('../assets/img/share4.png'),
      ],
      monthcard: [
        require('../assets/img/monthcard1.png'),
        require('../assets/img/monthcard2.png'),
        require('../assets/img/monthcard3.png'),
      ],
      userpay: [
        require('../assets/img/userpay.png'),
        require('../assets/img/userpay1.png'),
        require('../assets/img/userpay2.png'),
      ],
      fapiao: [
        require('../assets/img/fapiao1.png'),
        require('../assets/img/fapiao2.png'),
        require('../assets/img/fapiao3.png'),
      ],
    };
  },
};
</script>

<style scoped>
.appdown {
  position: absolute;
  top: -100px;
}


.textdetaile {
  padding-left: 30px;
}
.yztc {
  display: flex;
  justify-content: space-around;
  padding-top: 260px;
}
.carousel {
  width: 50%;
  height: 50%;
  display: flex;
  justify-content: center;
  align-content: center;
}
.carousel-warp {
  width: 100%;
}
/* .bg {
  background-image: url('../assets/img/cz.png');
  width: 100%;
  height: 500px;
  color: #ffffff;
  background-size: 100% 100%;
} */
.text {
  float: right;
  position: relative;

  bottom: -50px;
}
.textdetaile {
  padding-left: 30px;
}
h1 {
  font-size: 25px;
color: #0C7FE5;
font-weight: 500;
margin-top: 60px;
}
.text div {
  padding: 8px;
  font-size: 18px;
}
.text p {
  font-size: 18px;
}
.text div ::before {
  content: '.';
  color: gray;
  padding: 7px;
  height: 7px;
}
</style>


// WEBPACK FOOTER //
// src/components/cz.vue